<template>
  <vue-seamless-scroll v-if="screenWidth>540" :data="listData" :class-option="classOption" class="warp">
    <ul class="ul-item">
      <li class="li-item" v-for="(item, index) in listData" :key="index">
        <img :src="item" alt="" class="listData-logo-item img-shadow">
      </li>
    </ul>
  </vue-seamless-scroll>
  <div v-else  style="width: 80%;display: flex;align-items: center;justify-content: center;padding-top: 2rem;margin: 0 auto;">
    <el-row :gutter="10">
      <el-col :span="8" style="margin-bottom: 2rem" v-for="item in listData" :key="item">
        <div style="width:100%;">
          <img class="img-shadow" :src="item" alt="" width="100%">
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import { listInfo } from '@/api/index'
import { mapState } from 'vuex'
export default {
  name: 'Example03Basic',
  components: {
    vueSeamlessScroll
  },
  computed: {
    ...mapState(['themeColor', 'screenWidth']),
  },
  data() {
    return {
      councilImgs: [],
      listData: [],
      classOption: {
        limitMoveNum: 1,
        direction: 2,
        step: 0.3,
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0,
        waitTime: 2000,
      }
    }
  },
  created() {
    this.listCouncil()
  },
  methods: {
    //理事单位
    listCouncil() {
      const formData = new FormData();
      formData.append("moduleId", 19);
      listInfo(formData).then(res => {
        if (res.data && res.data != null) {
          for (var i = 0; i < res.data.length; i++) {
            this.councilImgs.push(res.data[i].imgUrl);
          }
          this.listData = this.councilImgs;
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.warp {
  width: 90%;
  margin: 0 auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    &.ul-item {
      display: flex;
      .li-item {
        width: 10rem !important;
        margin-right: 2rem;
        // background-color: #999;
        color: #fff;
        text-align: center;
        font-size: 1.5rem;
      }
    }
  }
}
.listData-logo-item {
  width: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.img-shadow{
  box-shadow: #f0eeee 0px 0px 0.3rem;
}
</style>